import { WalletTransaction } from '../../../utilities/account/useWallet'
import { TransactionType } from '../../../typings'
import { i18n } from '../../../localization'

/**
 * source: public/partials/conda-wallet-shortcode/shortcode-parts/wallets.php:195
 * @param transaction
 * @param email
 */
function amountIsNegative(transaction: WalletTransaction, email: string): boolean {
    if (transaction.type === TransactionType.MONEY_IN) {
        return false
    }
    if (transaction.type === TransactionType.MONEY_OUT) {
        return true
    }
    if (transaction.type === TransactionType.P2P) {
        return transaction.from === email
    }
}

export function getTransactionAmount(transaction: WalletTransaction, email: string): number {
    return amountIsNegative(transaction, email) ? -transaction.amount : transaction.amount
}

export function getTransactionPaymentMethod(transaction: WalletTransaction): string {
    if (transaction.type === TransactionType.P2P) {
        return i18n.global.t('wallet.lw_trasaction_type.' + transaction.type)
    } else {
        return i18n.global.t('wallet.lw_trasaction_method.' + transaction.method)
    }
}

export function getTransactionTitle(transaction: WalletTransaction) {
    if (transaction.transaction_purpose_text) {
        return transaction.transaction_purpose_text
    }
    return transaction.asset_title
}

/**
 * source: class-conda-investment-desk-utilities.php:2523
 * TODO: i18n
 * @param type
 */
function getTransactionType(type) {
    switch (type) {
        case 0:
            return 'money-in'
        case 1:
            return 'money-out'
        case 2:
            return 'p2p'
        default:
            return ''
    }
}

/**
 * source: class-conda-investment-desk-utilities.php:2523
 * TODO: i18n
 * @param method
 */
function getTransactionMethod(method) {
    switch (method) {
        case 0:
            return 'Payment via credit card'
        case 1:
            return 'Payment via wire transfer'
        case 3:
            return 'Payout via wire transfer'
        case 13:
            return 'Payment via iDeal'
        case 14:
            return 'Payment via direct debit'
        case 15:
            return 'Payment via cheque'
        case 16:
            return 'Payment via Neosurf card'
        default:
            return ''
    }
}
